import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import useScrollToTop from '../hooks/useScrollToTop'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const ProgramDetails = () => {
    useScrollToTop()
    const [isProgramData, setIsProgramData] = useState([]);
    const [loading, setLoading] = useState(true);
    const[isNoData,setIsNoData]=useState(false)
    useEffect(() => {
        const programDataFetch = async () => {
            try {
                const responseProgram = await OtherService.programDetails()
                if(responseProgram.error == false && responseProgram.data.content_banner_details_contact.content_spot_contents.length > 0 )
                {
                
                setIsProgramData(responseProgram.data.content_banner_details_contact.content_spot_contents)
                setLoading(false)
                setIsNoData(false);
                }
                else{
                    setLoading(false);
                    setIsNoData(true);
                }
            }
            catch (e) {
                console.error("e")

            }
        }
        programDataFetch()
    }, [])
    return (
        <> 
             {/* {loading && <Loader/> } */}
           
            <BreadCrumbSecttion pageTitle="Program Details" currentPageName="Program Details" />
            <section className='padTop50'>
               {isNoData &&  <div className='noDataMsg'>No data found!</div>}
               {!isNoData &&
                <Container>
                    <Row>
                        <Col xs={12}>
                           <div className="userInfoBox">
                                    {isProgramData?.map((item) => {
                                        const { content_map_id, article_detail, article_text } = item
                                        
                                        return (
                                            <div key={content_map_id}>
                                                <h2 className='articleTitle gradient-text'>{article_text}</h2>
                                                {/* {article_detail} */}
                                                {/* <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(article_detail)}} className='mb-4 faqParagraphBox'> */}
                                                    <div>
                                                        {parseSafeHtml(article_detail)}
                                                    </div>
                                                {/* </div> */}
                                            </div>
                                        )
                                    })}
                            </div>
                        </Col>
                    </Row>
                </Container>
               }
            </section>

        </>
    )
}

export default ProgramDetails